import { Rating as Ratings } from 'primereact/rating';  

const Rating = ({...rest}) => {

    return (
        <Ratings {...rest} />
    )

};

export default Rating;